import { SxProps, Theme } from "@mui/material/styles";

export const EMPTY_LABEL = "Selecione";
export const ALL_LABEL = "Todos";
export const ALL_VALUE = "__all__";

export const RESERVED_WIDTH = 56;
export const BADGE_WIDTH = 36;
export const BADGE_GAP = 8;

export const formControlSx = (theme: Theme): SxProps<Theme> => ({
  width: "100%",
  height: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: `${theme.shape.borderRadius}px`,
    fontFamily: theme.typography.fontFamily,
  },
});

export const inputLabelSx = (theme: Theme): SxProps<Theme> => ({
  position: "absolute",
  top: "-2px",
  left: "12px",
  color: theme.palette.text.primary,
  fontFamily: theme.typography.fontFamily,
  fontSize: "20px",
  fontWeight: 700,
  backgroundColor: theme.palette.background.paper,
  px: "0.8rem",
  ml: 0,
  width: "auto",
  transform: "translate(0, -9px) scale(0.75)",
  "&.Mui-focused": {
    color: theme.palette.text.primary,
  },
  "&.Mui-error": {
    color: theme.palette.text.primary,
  },
});

export const selectSx = (theme: Theme): SxProps<Theme> => ({
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  mt: 0,
  minHeight: "5rem",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  fontFamily: theme.typography.fontFamily,
  fontSize: "16px",
  fontWeight: 400,
  pl: "14px",
  borderRadius: `${theme.shape.borderRadius}px`,
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(114, 101, 81, 0.20)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(114, 101, 81, 0.35)",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.main,
    borderWidth: "1px",
  },
  "& .MuiSelect-icon": {
    color: theme.palette.primary.main,
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    minHeight: "22px",
    paddingLeft: 0,
  },
});

export const menuPaperSx = (theme: Theme): SxProps<Theme> => ({
  mt: 1,
  borderRadius: `${theme.shape.borderRadius}px`,
  maxHeight: 560,
  boxShadow: "0px 8px 24px rgba(0,0,0,0.12)",
  backgroundColor: theme.palette.background.paper,
});

export const menuItemBaseSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  pt: "1rem",
  px: 2,
  pb: 1,
};

export const allMenuItemSx: SxProps<Theme> = {
  ...menuItemBaseSx,
  height: "6rem",
};

export const optionMenuItemSx = (isSubTitle: boolean): SxProps<Theme> => ({
  ...menuItemBaseSx,
  height: isSubTitle ? "6rem" : "5rem",
});

export const checkboxSx = (
  theme: Theme,
  isMobile: boolean
): SxProps<Theme> => ({
  p: isMobile ? "5px" : "4px",
  mr: isMobile ? "10px" : 1,
  color: theme.palette.primary.main,
  width: isMobile ? "10px" : "auto",
  "&.Mui-checked": {
    color: theme.palette.primary.main,
  },
  "&.MuiCheckbox-indeterminate": {
    color: theme.palette.primary.main,
  },
  "& .MuiSvgIcon-root": {
    width: 18,
    height: 18,
  },
});

export const titleTypographySx = (
  theme: Theme,
  isMobile: boolean
): SxProps<Theme> => ({
  color: theme.palette.text.primary,
  fontFamily: theme.typography.fontFamily,
  fontSize: isMobile ? "12px" : "16px",
  fontWeight: 400,
  lineHeight: 1.2,
  whiteSpace: "normal",
  wordBreak: "break-word",
});

export const subTitleTypographySx = (theme: Theme): SxProps<Theme> => ({
  color: theme.palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "46px",
  p: 0,
  mt: "-1.2rem",
});

export const placeholderTextStyle = (theme: Theme): React.CSSProperties => ({
  color: theme.palette.text.disabled,
  fontFamily: theme.typography.fontFamily,
  fontSize: "16px",
  fontWeight: 400,
});

export const badgeStyle = (theme: Theme): React.CSSProperties => ({
  minWidth: "24px",
  height: "24px",
  padding: "0 6px",
  borderRadius: "999px",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.background.paper,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "11px",
  fontWeight: 700,
  flexShrink: 0,
});

export const valueContainerStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  width: "100%",
  minWidth: 0,
  gap: "8px",
};

export const valueTextStyle: React.CSSProperties = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  flex: 1,
  minWidth: 0,
};
